import { Tabs, Typography } from 'antd';
import React, { useState } from 'react'
import BookingList from './BookingList';
import { DatePicker, Space } from 'antd';

export default function BookingTabs() {

    const onChange = (key) => {
        console.log(key);
        setCurrentStatus(key);
    };

    const[currentStatus, setCurrentStatus] = useState("PENDING");
    const items = [
        {
            key: 'PENDING',
            label: <p className="text-lg font-semibold text-footerBlue">U obradi</p>,
            children: <BookingList currentStatus={currentStatus}/>,
        },
        {
            key: 'RESERVED',
            label: <p className="text-lg font-semibold text-footerBlue">Odobrene</p>,
            children: <BookingList currentStatus={currentStatus}/>,
        },
        {
            key: 'REJECTED',
            label: <p className="text-lg font-semibold text-footerBlue">Odbijene</p>,
            children: <BookingList currentStatus={currentStatus}/>,
        },
    ];
    return (
        <div className="container mx-auto px-4 py-4 overflow-auto" style={{ minHeight: 'calc(100vh - 100px)' }}>
            <Tabs type="card" defaultActiveKey="1" items={items} onChange={onChange} />
        </div>
    );
}
